// The keys and values should match
export enum BrakingAttributeAlertLevel {
  none = 'none',
  softBraking = 'softBraking',
  normalBraking = 'normalBraking',
  hardBraking = 'hardBraking',
  emergencyBraking = 'emergencyBraking',
  fullEmergencyBraking = 'fullEmergencyBraking',
}
